import { render, staticRenderFns } from "./SettingsMenuView.vue?vue&type=template&id=2552e849&"
import script from "./SettingsMenuView.vue?vue&type=script&lang=js&"
export * from "./SettingsMenuView.vue?vue&type=script&lang=js&"
import style0 from "./SettingsMenuView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTab,VTabs,VTabsSlider})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2552e849')) {
      api.createRecord('2552e849', component.options)
    } else {
      api.reload('2552e849', component.options)
    }
    module.hot.accept("./SettingsMenuView.vue?vue&type=template&id=2552e849&", function () {
      api.rerender('2552e849', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/SettingsMenuView.vue"
export default component.exports